import { RadioGroup as MUIRadioGroup, RadioGroupProps } from '@mui/material';

export { type RadioGroupProps } from '@mui/material';

export function RadioGroup(props: RadioGroupProps) {
  return <MUIRadioGroup {...props} />;
}
